const TokenKey = 'App-Token';

export const getToken = () => {
    return localStorage.getItem(TokenKey);
}

export const setToken = (access_token) => {
    console.log('存token',access_token);
    localStorage.setItem(TokenKey, access_token);
};

export const removeToken = () => {
    console.log('删除token',TokenKey);
    localStorage.removeItem(TokenKey);
};
